import {
  Component,
  ChangeDetectionStrategy,
  Input,
  DoCheck
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-reactive-text-input',
  templateUrl: './reactive-text-input.component.html',
  styleUrls: ['./reactive-text-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReactiveTextInputComponent implements DoCheck {
  /**
   * 'fieldId' is a unique field identification
   * Example: 'email', 'password'
   *    ---REQUIRED PROPERTY---
   */
  @Input() isInline = false;
  @Input() showError = true;
  @Input() fieldId: string;
  @Input() filedLabel: string;
  @Input() placeHolder: string;
  @Input() filedType = 'text'; // default value is string
  @Input() icon: string;
  @Input() ovalShaped = false;
  @Input() lineShaped = false;
  @Input() readOnly = false;
  @Input() autocomplete = false;
  @Input() showTooltip = false;
  @Input() descriptionTooltip: string;
  @Input() topTooltipHover: number;
  @Input() leftTooltipHover: number;
  @Input() touched: boolean;
  @Input() maxlength = 30;
  @Input() min = null;
  @Input() usingPositiveNumber = false;
  /**
   * 'control' is a reactive form validator/value controller
   *    ---REQUIRED PROPERTY---
   */
  @Input() control: AbstractControl;

  private _validationErrors = new BehaviorSubject<object>(null);
  public validationErrors$ = this._validationErrors.asObservable();

  ngDoCheck() {
    // console.log('here i am  ');
    if (
      this.control &&
      this.control.invalid &&
      this.control.touched &&
      this.showError
    ) {
      this._validationErrors.next(this.control['errors']);
    } else {
      this._validationErrors.next(null);
    }
  }
}
